<template>
    <b-overlay :show="loading" rounded="sm" class="w-100">
        <LocalizationProvider :language="kendoLang">
        <IntlProvider :locale="kendoLang">
            <Grid id="pig-grid" ref="grid" :data-items="gridData"
                     :resizable="true" :reorderable="true" :sortable="true"  :groupable="false" :selectable="true"
                     :filterable="false" :column-menu="false" 
                    :pageable="true" :group="group" :sort="sort" :filter="filter" :take="take"
                    :skip="skip" :columns="columns" 
                    :selected-field="selectedField" 
                    @pagechange="pageChangeHandler"
                    @rowclick="onRowClick"
                    >

                    <!--Header Cell template Starts-->
                    <template v-slot:StatusHeaderTemplate="{props}">
                        <div class="status-header-cell">
                            <span>{{ props.title }}</span>
                            <i class="fa fa-info-circle ml-1" v-bind:t_label="'EMPBE_PIG_Grid_Status_Info'" id="StatusInfo"></i>
                            <b-tooltip target="StatusInfo" triggers="hover focus" placement="bottom">
                                <span v-html="$t('lbl_EMPBE_PIG_GridStatusInfo')"></span>
                            </b-tooltip>
                        </div>
                    </template>

                    <template v-slot:LastSubmissionDateHeaderTemplate="{props}">
                        <div class="submission-header-cell">
                            <span>{{ props.title }}</span>
                            <i class="fa fa-info-circle ml-1" v-bind:t_label="'EMPBE_PIG_Grid_Submission_Info'" id="SummissionInfo"></i>
                            <b-tooltip target="SummissionInfo" triggers="hover focus" placement="bottom">
                                <span v-html="$t('lbl_EMPBE_PIG_GridSubmissionInfo')"></span>
                            </b-tooltip>
                        </div>
                    </template>
                    <!--Header Cell template Ends-->

                    <!--Cell template Starts-->
                    <template v-slot:EndProductNameTemplate="{props}">
                        <td>
                            <div class="d-flex align-items-center" style="gap: 0.5rem">
                                <span class="textlengthdrop flex-grow-1">
                                    {{ props.dataItem.EndProductName }}
                                </span>
                                <span class="text-default edit-badge" style="flex: 0 0 auto;">
                                    <img class="textlengthdrop-img" src="../../../assets/images/edit.svg"/>
                                    {{ $t("lbl_EMPBE_edit") }}
                                </span>
                                <a v-if="props.dataItem.PIGUrl" class="text-default edit-badge"  style="flex: 0 0 auto;" target="_blank" :href="props.dataItem.PIGUrl">
                                    <i class="fa fa-eye"></i>
                                    {{ $t("lbl_EMP3_PIG_View") }}
                                </a>
                            </div>
                        </td>
                    </template>
                    <template v-slot:RelatedToTemplate="{props}">
                        <td>
                            <span>
                                {{ props.dataItem.RelatedTo }}
                            </span>
                        </td>
                    </template>
                    <template v-slot:StatusTemplate="{props}">
                        <td>
                            <span class="Status" :class="props.dataItem.Status">
                                {{ $t(`lbl_EMPBE_PIG_${props.dataItem.Status}`) }}
                            </span>
                        </td>
                    </template>                  
                    <!--Cell template Ends-->

            </Grid>
        </IntlProvider>
    </LocalizationProvider>
    </b-overlay>

</template>

<script>
import {
  IntlProvider,
  load,
  LocalizationProvider,
  loadMessages,
} from "@progress/kendo-vue-intl";
import { Grid, GridToolbar } from "@progress/kendo-vue-grid";
import { Input } from "@progress/kendo-vue-inputs";
import { DropDownList } from "@progress/kendo-vue-dropdowns";
import { endProductService } from '@/_services/endproduct.service';
import { process } from "@progress/kendo-data-query";


export default{
    components:{
        Grid, 
        GridToolbar,
        LocalizationProvider,
        IntlProvider,
        KInput : Input,
        DropDownList,
    },

    props: ["res"],

    data(){
        return{
            rawData: [], // rawdata -> mappeddata -> griddata
            loading:true,
            gridData: [], 
            mappedData: [],
            group: [],
            sort: [],
            filter: null,
            take: 10,
            skip: 0,
            gridPageable: {
                info: true,
                pageSizes: false,
            },
            columns:[
                {
                    field: "id",
                    title: "#",
                    width: "60px",
                    locked: true
                },
                {
                    field: "EndProductName",
                    title: this.$t("lbl_EMPBE_EndProductName"),
                    cell: "EndProductNameTemplate",
                    width: "300px",
                },
                {
                    field: "Hall",
                    title: this.$t("lbl_EMPBE_Hall"),
                    width: "150px",
                },
                {
                    field: "DisplayNo",
                    title: this.$t("lbl_EMPBE_PIG_DisplayNo"),
                    width: "150px",
                },
                {
                    field: "DisplayGrade",
                    title: this.$t("lbl_EMPBE_PIG_DisplayType"),
                    width: "150px",
                },
                {
                    field: "Theme",
                    title: this.$t("lbl_EMPBE_PIG_ApplicationIndustry"),
                    width: "180px",
                },
                {
                    field: "RelatedTo",
                    title: this.$t("lbl_EMPBE_RelatedTo"),
                    cell: "RelatedToTemplate",
                    width: '280px',
                },
                {
                    field: "Status",
                    title: this.$t("lbl_EMPBE_Status"),
                    cell: "StatusTemplate",
                    headerCell: "StatusHeaderTemplate",
                    width: '150px',
                },
                {
                    field: "LastSubmissionDate",
                    title: this.$t("lbl_EMPBE_LastSubmissionDate"),
                    headerCell: "LastSubmissionDateHeaderTemplate",
                    width: '200px',
                },
            ],
            selectedField: "selected",
            dateSortingData: [
                { value: "asc", text: this.$t("lbl_EMP2_Sort_Asc") },
                { value: "desc", text: this.$t("lbl_EMP2_Sort_Dsc") }
            ],
            dateSortingDefault: { value: '', text: this.$t('Lbl_News_SortByDate') },
            realFormLockDeadline: "",
            firstDisplayDeadline: "",
            secondDisplayDeadline: "",
        }
    },
    // mounted() {
    //     this.init();
    // },
    // created() {
    //     this.gridData = this.MapToGrid(this.rawData);
    // },

    computed: {
        isDeadlineMet(){
            const that = this;
            const deadline = this.$moment(that.realFormLockDeadline).utc().utcOffset(8);
            const currDate = this.$moment().utc().utcOffset(8);

            return deadline.isSameOrBefore(currDate);
        },

        HallData(){
            return []
        },
        ThemeData(){
            return []
        },
        statusData(){
            return [];
        },
        user() {          
            return this.$store.state.authentication.user;
        },
        companyid() {
            return this.user.empCompanyId
        },
        kendoLang() {
            var langid = localStorage.getItem("currentLangId");
            switch (langid) {
                case "1252":
                return "en-US";
                case "950":
                return "zh-Hant";
                case "936":
                return "zh-Hans";
                default:
                return "zh-Hans";
            }
        },
    },

    watch: {
        res: {
            handler(val) {
                if (!val) {
                    return;
                };

                const that = this;

                that.rawData = val.endProductList;
                that.totalRows = that.rawData.length;

                // Map Raw data into table
                that.MapToGrid(that.rawData);

                that.realFormLockDeadline = val.realFormLockDeadline;
                that.firstDisplayDeadline = val.firstDisplayDeadline;
                that.secondDisplayDeadline = val.secondDisplayDeadline;
            },
            deep: true,
        }
    },

    methods:{
        setIsLoading(isLoading) {
            this.loading = isLoading;
        },
        // init() {
        //     // Get Data From server
        //     this.GetPIGData();
            
        // },
        // GetPIGData(){
        //     var that = this;
        //     this.loading = true;
        //     //Use jwt token to get companyid
        //     endProductService.GetListByCompanyId(this.companyid).then((res)=>{
        //         if(res.isSuccessful){
        //             that.rawData = res.data.endProductList;
        //             that.totalRows = that.rawData.length;

        //             // Map Raw data into table
        //             that.MapToGrid(that.rawData);

        //             that.realFormLockDeadline = res.data.realFormLockDeadline;
        //             that.firstDisplayDeadline = res.data.firstDisplayDeadline;
        //             that.secondDisplayDeadline = res.data.secondDisplayDeadline;
        //         }
        //     }).finally(() => {
        //         that.loading = false;
                
        //     })
        // },
        MapToGrid(rawData){
            const now = this.$moment();
            
            this.mappedData = rawData.map((x, id) => {
                const is24HoursLater = x.lastSubmitDate && now.diff(this.$moment(x.lastSubmitDate), "hours") >= 24;
                const isShowPIGUrl = x.status && x.status.toUpperCase() === "ACTIVE" && is24HoursLater;

                return {
                    id: id + 1,
                    EndProudctId: x.endProductId,
                    EndProductName: x.endProductName ? x.endProductName : this.$t("lbl_EMPBE_PIG_InputExhibitNameReminder", { exhibitNo: id + 1 }),
                    DisplayNo: x.displayNo ? x.displayNo.split("|").join(", ") : "-",
                    DisplayGrade: x.displayGrade,
                    Hall: x.displayHall ? x.displayHall.split("|").join(", ") : "-",
                    Theme: x.displayCate ? x.displayCate : "-" ,
                    RelatedTo: x.empProductName ? x.empProductName : "-",
                    LastUpdatedDate: x.lastUpdatedDate ? x.lastUpdatedDate : "-",
                    LastSubmissionDate : x.lastSubmitDate ? x.lastSubmitDate : "-",
                    Status : x.status && x.status.toUpperCase() === "DRAFT" ? "REQUIRED" : x.status, // Change from draft to required for style and label change
                    GalleryCatId : x.galleryCatId,
                    PIGUrl: this.isDeadlineMet && isShowPIGUrl ? `${process.env.VUE_APP_EMP_VIEW}productinnovationgallery?Id=${x.endProductId}` : "",
                };
            });

            const reqNums = this.mappedData?.reduce((accu, curr) => {
                return curr.Status.toUpperCase() === "REQUIRED" ? accu + 1 : accu;
            }, 0) ?? 0;

            this.$emit("onUpdateReqNum", reqNums);

            this.gridData = process(this.mappedData,{
                take: this.take,
                skip: this.skip,
                group: this.group,
                sort: this.sort,
                filter: this.filter
            })

        },
        pageChangeHandler: function (event) {
            this.loader = true;

            this.skip = event.page.skip
            this.take = event.page.take
            this.gridData = process(this.mappedData,{
                skip : this.skip,
                take : this.take,
            })

            this.loader = false;


        },
        onRowClick(event) {
            const pigId = event.dataItem.EndProudctId;
            // Let parent decide: same-window local sidebar (approval) or route sidebar (PIG page)
            this.$emit("openDetail", pigId);
        },
        getPIGUrl(id) {
            return ;
        },
        isShowPIGUrl(dataItem) {
            return this.user.role === "Admin" || this.user.role === "PIGAdmin";
        },
    }
}
</script>

<style lang="scss">
  @import "../style/grid"; 
</style>
<style scoped>
.textlengthdrop
{
  display: inline-block;
  /* white-space: nowrap; */
  overflow: hidden;      
  text-overflow: ellipsis; 
}
.textlengthdrop-img
{

    margin: 0px 2px 2px 0px;
}

</style>